import Header from "@/components/Header";
import Hero from "@/components/Hero";
import SocialFeed from "@/components/SocialFeed";
import ServicesShowcase from "@/components/ServicesShowcase";
import PromoVideo from "@/components/PromoVideo";
import About from "@/components/About";
import Services from "@/components/Services";
import WhyChooseUs from "@/components/WhyChooseUs";
import Industries from "@/components/Industries";
import OurStrength from "@/components/OurStrength";
import CtaContact from "@/components/CtaContact";
import RequestQuote from "@/components/RequestQuote";
import LegalDocuments from "@/components/LegalDocuments";
import Footer from "@/components/Footer";
import SEOEnhancements from "@/components/SEOEnhancements";
import EidMubarakBanner from "@/components/EidMubarakBanner";
import { useSecurityWatcher } from "@/hooks/useSecurityWatcher";

const Index = () => {
  useSecurityWatcher();
  return (
    <div className="min-h-screen">
      <SEOEnhancements />
      <Header />
      <EidMubarakBanner />
      <Hero />
      <PromoVideo />
      <ServicesShowcase />
      <Services />
      <About />
      <WhyChooseUs />
      <Industries />
      <OurStrength />
      <SocialFeed />
      <CtaContact />
      <LegalDocuments />
      <RequestQuote />
      <Footer />
    </div>
  );
};

export default Index;
